import { styled } from '@linaria/react';
import chroma from 'chroma-js';

function GradientColorBreakdown({ color, colorMode }) {
  if (colorMode === 'hsl') {
    return (
      <Wrapper>
        <Row>
          <Key>HUE:</Key> {Math.round(color.get('hsl.h'))}
        </Row>
        <Row>
          <Key>SAT:</Key> {Math.round(color.get('hsl.s') * 100)}
        </Row>
        <Row>
          <Key>LIT:</Key> {Math.round(color.get('hsl.l') * 100)}
        </Row>
      </Wrapper>
    );
  }
  if (colorMode === 'hcl') {
    return (
      <Wrapper>
        <Row>
          <Key>H:</Key> {Math.round(color.get('hcl.h'))}
        </Row>
        <Row>
          <Key>C:</Key> {Math.round(color.get('hcl.c') * 100)}
        </Row>
        <Row>
          <Key>L:</Key> {Math.round(color.get('hcl.l') * 100)}
        </Row>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <Row>
        <Key>R:</Key> {color.get('rgb.r')}
      </Row>
      <Row>
        <Key>G:</Key> {color.get('rgb.g')}
      </Row>
      <Row>
        <Key>B:</Key> {color.get('rgb.b')}
      </Row>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 3px;
  height: 100%;
  font-family: var(--font-family-mono);
`;

const Row = styled.div`
  display: flex;
  gap: 8px;
`;

const Key = styled.div`
  font-weight: var(--font-weight-medium);
`;

export default GradientColorBreakdown;
